import { render } from "./GnssTag.vue?vue&type=template&id=39cb2d04&scoped=true"
import script from "./GnssTag.vue?vue&type=script&lang=js"
export * from "./GnssTag.vue?vue&type=script&lang=js"

import "./GnssTag.vue?vue&type=style&index=0&id=39cb2d04&scoped=true&lang=css"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39cb2d04"]])

export default __exports__